import { useEffect } from 'react';
import * as state from '@/state';
import { useGetAllZonesForAssetLabellingQuery } from '@/__generated__/graphql';
import { useSetAtom } from 'jotai';

export const useGetAllZones = (structureId: string) => {
  const setZones = useSetAtom(state.zones);
  const setSelectedZone = useSetAtom(state.selectedZone);

  const zonesResult = useGetAllZonesForAssetLabellingQuery({
    variables: {
      structureId: structureId,
    },
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    const { data, loading, error } = zonesResult;
    if (loading) return;
    if (error) {
      throw new Error('Unable to fetch structure zones');
    }
    setZones(data?.zonesForStructure ?? []);
  }, [zonesResult, setZones, setSelectedZone]);

  return { isLoading: zonesResult.loading };
};
